// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/@nrwl/web/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".challengeDatePicker_picker__HkEbz input::placeholder {\n  color: var(--red);\n}", ""]);
// Exports
exports.locals = {
	"picker": "challengeDatePicker_picker__HkEbz"
};
module.exports = exports;
